import React from 'react';
import { MetricConfig, MetricData } from '../../types/metrics';
import StatCard from './StatCard';
import ChartRenderer from './ChartRenderer';
import TableRenderer from './TableRenderer';
import TabbedTableRenderer from './TabbedTableRenderer';

interface MetricRendererProps {
  config: MetricConfig;
  data: MetricData | null;
  loading: boolean;
  error?: string | null;
  storeId?: string | null;
  startDate?: string;
  endDate?: string;
}

const MetricRenderer: React.FC<MetricRendererProps> = ({ 
  config, 
  data, 
  loading, 
  error,
  storeId,
  startDate,
  endDate
}) => {
  console.log(`🔍 MetricRenderer ${config.id} - Tipo:`, config.type);
  console.log(`🔍 MetricRenderer ${config.id} - Datos:`, data);
  console.log(`🔍 MetricRenderer ${config.id} - Loading:`, loading);
  console.log(`🔍 MetricRenderer ${config.id} - Error:`, error);
  switch (config.type) {
    case 'stat-card':
      return (
        <StatCard 
          config={config} 
          data={data} 
          loading={loading} 
          error={error}
          storeId={storeId}
          startDate={startDate}
          endDate={endDate}
        />
      );
    case 'chart':
      return (
        <ChartRenderer
          config={config}
          data={data}
          loading={loading}
          error={error}
          startDate={startDate}
          endDate={endDate}
        />
      );
    case 'table':
      return <TableRenderer
        config={config}
        data={data}
        loading={loading}
        error={error}
        storeId={storeId}
        startDate={startDate}
        endDate={endDate}
      />;
    case 'tabbed-table':
      return <TabbedTableRenderer 
        config={config} 
        data={data} 
        loading={loading} 
        error={error}
        storeId={storeId}
        startDate={startDate}
        endDate={endDate}
      />;
    default:
      return <div>Tipo no soportado: {config.type}</div>;
  }
};

// Memoizar componente para evitar re-renders innecesarios
export default React.memo(MetricRenderer, (prevProps, nextProps) => {
  // Comparar props relevantes
  return (
    prevProps.config.id === nextProps.config.id &&
    prevProps.loading === nextProps.loading &&
    prevProps.error === nextProps.error &&
    prevProps.storeId === nextProps.storeId &&
    prevProps.startDate === nextProps.startDate &&
    prevProps.endDate === nextProps.endDate &&
    // Comparar datos: si ambos son null/undefined, son iguales
    // Si uno es null y el otro no, son diferentes
    // Si ambos tienen datos, comparar el valor
    (prevProps.data === nextProps.data || 
     (prevProps.data?.value === nextProps.data?.value && 
      JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data)))
  );
}); 